<div class="row filter-row filter-sticky" [style.height]="customHeight || 'auto'">
  <div class="col-lg-12" *ngIf="statusOptions?.length > 0" style="margin-top: 20px">
    <label class="title-text">Status</label>
    <mat-checkbox class="d-block" *ngFor="let status of statusOptions" [(ngModel)]="status.selected" (change)="updateStatus(status.option, $event)">
      {{ status.option }}
    </mat-checkbox>
  </div>

  <div class="col-lg-12" *ngIf="deletionReasonOptions?.length > 0">
    <label class="title-text">Motivo da exclusão</label>
    <mat-checkbox
      class="d-block"
      *ngFor="let reason of deletionReasonOptions"
      [(ngModel)]="reason.selected"
      (change)="updateDeletionReason(reason.option, $event)"
    >
      {{ reason.option }}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-3" [style.marginTop]="statusOptions?.length > 0 || deletionReasonOptions?.length > 0 ? 0 : '20px'">
    <label class="title-text">Buscar veículo</label>
    <mat-form-field appearance="fill">
      <input matInput [(ngModel)]="filter.searchQuery" (keydown.enter)="submitFilter()" />
      <mat-icon matSuffix (click)="submitFilter()" class="cursor-pointer">search</mat-icon>
    </mat-form-field>
  </div>

  <div class="col-lg-12">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Localização</label>
      </div>
    </div>
    <mat-form-field appearance="fill">
      <mat-label class="title-label">Digite um estado ou cidade</mat-label>

      <input type="text" matInput [formControl]="cityUfCompleteControl" [matAutocomplete]="cityUfAutocomplete" (input)="onInput($event)" />
      <mat-icon matSuffix class="cursor-pointer">search</mat-icon>
    </mat-form-field>

    <mat-autocomplete #cityUfAutocomplete="matAutocomplete" [displayWith]="getCityUf" (optionSelected)="selectedCityUf($event)" autoActiveFirstOption>
      <mat-option *ngFor="let option of cityUfOptions" [value]="option">
        <ng-container *ngIf="option.type === 'CITY'; else otherLabel"> {{ option.name }} - {{ option.uf }} </ng-container>
        <ng-template #otherLabel>
          {{ option.name }}
        </ng-template>
      </mat-option>
    </mat-autocomplete>
  </div>

  <div class="col-lg-12 selected-buttons-container" *ngIf="selectedUfCitys.length > 0">
    <button class="button-selected-option" *ngFor="let option of selectedUfCitys">
      <ng-container *ngIf="option.type === 'CITY'; else otherLabel">
        <span>{{ option.name }} - {{ option.uf }}</span>
      </ng-container>
      <ng-template #otherLabel>
        <span>{{ option.uf }}</span>
      </ng-template>
      <i class="material-icons icon-right" (click)="removeSelectetCityUf(option)">close</i>
    </button>
  </div>

  <div class="col-lg-12" *ngIf="filter.myVehicles">
    <div class="location-field">
      <mat-form-field>
        <mat-label class="title-text">Pátio</mat-label>
        <mat-select [(value)]="filter.locationId">
          <mat-option></mat-option>
          <mat-option *ngFor="let location of locations" [value]="location.id">{{ location.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="col-lg-12" *ngIf="filter.myVehicles && auctionLastPublishedByOptions.length > 0">
    <div class="location-field">
      <mat-form-field>
        <mat-label class="title-text">Usuário da publicação</mat-label>
        <mat-select [(value)]="filter.auctionLastPublishedBy">
          <mat-option></mat-option>
          <mat-option *ngFor="let publicationUser of auctionLastPublishedByOptions" [value]="publicationUser.id">
            {{ publicationUser.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="col-lg-12" *ngIf="filter.myVehicles">
    <mat-form-field>
      <mat-label class="title-text">Tipo de importação</mat-label>
      <mat-select [formControl]="reportTypeControl" multiple (selectionChange)="selectReportType($event)">
        <mat-option *ngFor="let reportType of reportTypeOptions" [value]="reportType.value">
          {{ reportType.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-12" *ngIf="filter.myVehicles && selectedReportTypes?.length > 0">
    <div class="selected-buttons-container">
      <button class="button-selected-option" *ngFor="let reportType of selectedReportTypes">
        <span>{{ reportType.label }}</span>
        <i class="material-icons icon-right" (click)="removeReportType(reportType.value)">close</i>
      </button>
    </div>
  </div>

  <div class="col-lg-12 mt-2 mb-2" *ngIf="filter.myVehicles">
    <label class="title-text">Fotos</label>
    <mat-radio-group [(ngModel)]="selectedPhotoOption">
      <mat-radio-button class="d-block" *ngFor="let photoOption of photoOptions" (change)="updatePhotoOptions(photoOption, $event)" [value]="photoOption">
        {{ photoOption }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="col-lg-12" *ngIf="!filter.myVehicles && page === 'ALL' && showDealTypeFilter && !hideDealTypeFilter">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Tipo de negociação</label>
      </div>
    </div>
    <ng-container *ngFor="let dealType of dealTypeOptions">
      <mat-checkbox *ngIf="dealType.quantity > 0" class="d-block" [(ngModel)]="dealType.selected" (change)="updateDealType(dealType.option, $event)">
        {{ dealType.option }} <span class="quantity-information ml-1"> ({{ dealType.quantity }})</span>
      </mat-checkbox>
    </ng-container>
  </div>

  <div class="col-lg-12" *ngIf="!filter.myVehicles && !hideOemDealerOptions">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Anunciantes</label>
      </div>
    </div>

    <mat-form-field appearance="fill">
      <mat-label class="title-label">Selecionar</mat-label>
      <mat-select placeholder="Toppings" [formControl]="oemDealerToppings" multiple (selectionChange)="handleSelectedValues($event)">
        <mat-select-trigger>
          {{ oemDealerToppings.value ? oemDealerToppings.value[0]?.name : "" }}
          <span *ngIf="oemDealerToppings.value?.length > 1" class="additional-selection">
            (+{{ oemDealerToppings.value.length - 1 }} {{ oemDealerToppings.value?.length === 2 ? "Anunciante" : "Anunciantes" }})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let oemDealer of oemDealerToppingsList" [value]="oemDealer">
          {{ oemDealer?.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="showSegmentFilter">
    <label class="title-text">Tipo de Veículo</label>
    <div class="row pr-3 d-flex mb-2">
      <div class="col-4 col-md-4" *ngFor="let segment of filteredSegments">
        <div
          class="card text-center card-type-vehicle-filter"
          [ngClass]="{ selected: filter.segments && filter.segments.indexOf(segment.segment) >= 0 }"
          (click)="changeSegment(segment.segment)"
        >
          <i [ngClass]="segment.iconClass" class="d-block mx-auto cursor-pointer"></i>
          {{ segment.segmentLabel }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <mat-form-field appearance="fill">
      <mat-label class="title-label">Digite uma marca ou modelo</mat-label>
      <input type="text" matInput [formControl]="modelAutoCompleteControl" [matAutocomplete]="model" />
      <mat-icon matSuffix class="cursor-pointer">search</mat-icon>
    </mat-form-field>

    <mat-autocomplete #model="matAutocomplete" [displayWith]="getModelName" (optionSelected)="selectedModel($event)" autoActiveFirstOption>
      <mat-option *ngFor="let option of modelOptions | async" [value]="option">{{ option.name }}</mat-option>
    </mat-autocomplete>
  </div>

  <div class="col-lg-12 container-initial-logo-make" *ngIf="selectedMakes.length === 0">
    <div class="d-flex justify-content-center align-items-center" *ngFor="let make of makeOptions | async; let i = index">
      <div class="content-logo-make-initial mb-2 cursor-pointer" *ngIf="i < 8" (click)="selectedMakeInitial(make)">
        <div class="logo-make-initicial">
          <img [src]="'https://' + (make?.imgUrl !== undefined ? make?.imgUrl : 'img.autoarremate.com.br/images/makes/no_image.png')" class="logo" />
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 selected-buttons-container" *ngIf="selectedMakes.length > 0">
    <div class="container-logo-make d-flex pb-2" *ngFor="let make of selectedMakes">
      <div class="logo-make">
        <img [src]="'https://' + (make?.imgUrl !== undefined ? make?.imgUrl : 'img.autoarremate.com.br/images/makes/no_image.png')" class="logo" />
      </div>
      <div class="content-model">
        <div class="d-flex justify-content-between">
          <span>{{ make.name }}</span>
          <i class="fa-light fa-times-circle cursor-pointer" (click)="removeSelectedMake(make)"></i>
        </div>
        <div>
          <div class="col-lg-12 selected-buttons-container-mat-chip" *ngIf="selectedModelsMake[make.id]">
            <button class="button-selected-option" *ngFor="let modelName of selectedModelsMake[make.id]">
              {{ getModelMakeName(make.id, modelName) }}
              <i class="material-icons icon-right" (click)="removeSelectedModelMake(make.id, modelName, make)">close</i>
            </button>
          </div>
          <mat-form-field appearance="fill" class="form-field-model-make">
            <mat-label class="title-label">Escolher o modelo</mat-label>
            <mat-select placeholder="Color" (selectionChange)="selectedModelMake($event)">
              <mat-option *ngFor="let option of make.models" [value]="{ make: make, option: option }">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Ano do modelo</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label class="title-label">De</mat-label>
          <mat-select [(value)]="filter.modelYearStart">
            <mat-option></mat-option>
            <mat-option *ngFor="let year of minYearOptions" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label class="title-label">Até</mat-label>
          <mat-select [(value)]="filter.modelYearEnd">
            <mat-option></mat-option>
            <mat-option *ngFor="let year of maxYearOptions" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Preço</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label class="title-label">Mínimo</mat-label>
          <input
            matInput
            currencyMask
            [options]="{
              prefix: 'R$ ',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }"
            [(ngModel)]="filter.priceStart"
          />
        </mat-form-field>
      </div>
      <div class="mat-divide-input"></div>
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label class="title-label">Máximo</mat-label>
          <input
            matInput
            currencyMask
            [options]="{
              prefix: 'R$ ',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }"
            [(ngModel)]="filter.priceEnd"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <div class="row">
      <div class="col-12">
        <label class="title-text">Km</label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label class="title-label">Mínimo</mat-label>
          <input
            matInput
            currencyMask
            [options]="{
              prefix: '',
              suffix: ' km',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }"
            [(ngModel)]="filter.kmStart"
          />
        </mat-form-field>
      </div>
      <div class="mat-divide-input"></div>
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label class="title-label">Máximo</mat-label>
          <input
            matInput
            currencyMask
            [options]="{
              prefix: '',
              suffix: ' km',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }"
            [(ngModel)]="filter.kmEnd"
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <div class="row align-items-center">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <label class="title-text">Fipe %</label>
        <span class="title-text-clear cursor-pointer" (click)="resetFipeSlider()">limpar</span>
      </div>
    </div>

    <div class="range-slider" *ngIf="minFipe !== undefined && maxFipe !== undefined">
      <mat-slider class="w-100" [min]="minFipe" [max]="maxFipe" [step]="1">
        <input matSliderStartThumb [(ngModel)]="selectedValueStart" (ngModelChange)="onFipeSliderChange()" />
        <input matSliderEndThumb [(ngModel)]="selectedValueEnd" (ngModelChange)="onFipeSliderChange()" />
      </mat-slider>
    </div>
    <div class="selected-value mt-2">
      <span>de {{ selectedValueStart }}% até {{ selectedValueEnd }}%</span>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <label class="title-text">Combustível</label>
    <mat-checkbox class="d-block" *ngFor="let fuel of fuelOptions" [(ngModel)]="fuel.selected" (change)="updateFuel(fuel.option, $event)">
      {{ fuel.option }} <span class="quantity-information ml-1"> ({{ fuel.quantity }})</span>
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2">
    <label class="title-text">Diferenciais de repasse</label>

    <mat-checkbox class="d-block" [(ngModel)]="filter.withDossier">
      Com RaioX Auto Arremate <span class="quantity-information ml-1"> ({{ dossierQuantity }})</span>
    </mat-checkbox>
    <mat-checkbox class="d-block" [(ngModel)]="filter.withReport"> Com laudo </mat-checkbox>

    <ng-container *ngIf="page === 'CAST_OFF' || page === 'ALL'">
      <mat-checkbox
        class="d-block"
        *ngFor="let reportStatus of reportStatusOptions"
        [(ngModel)]="reportStatus.selected"
        (change)="updateReportStatus(reportStatus.option, $event)"
      >
        Laudo {{ reportStatus.option.toLowerCase() }} <span class="quantity-information ml-1"> ({{ getReportQuantity(reportStatus.option) }})</span>
      </mat-checkbox>
    </ng-container>

    <mat-checkbox class="d-block" [(ngModel)]="filter.extraKey">
      Com chave reserva <span class="quantity-information ml-1"> ({{ carManualQuantity }})</span>
    </mat-checkbox>
    <mat-checkbox class="d-block" [(ngModel)]="filter.carManual">
      Com manual do proprietário <span class="quantity-information ml-1"> ({{ extraKeyOptions }})</span>
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2">
    <label class="title-text">Transmissão</label>
    <mat-checkbox
      class="d-block"
      *ngFor="let transmission of transmissionOptions"
      [(ngModel)]="transmission.selected"
      (change)="updateTransmission(transmission.option, $event)"
    >
      {{ transmission.option }} <span class="quantity-information ml-1"> ({{ transmission.quantity }})</span>
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="filter.myVehicles">
    <label class="title-text">Público Alvo</label>
    <mat-checkbox
      class="d-block"
      *ngFor="let target of allTargets"
      [checked]="filter.targets && filter.targets.indexOf(target) >= 0"
      (change)="updateTarget(target, $event)"
    >
      {{ getTargetLabel(target) }}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="filter.myVehicles && exclusiveGroups.length > 0">
    <label class="title-text font-weight-bold">Grupo Exclusivo</label>
    <mat-checkbox
      class="d-block"
      *ngFor="let group of exclusiveGroups"
      [checked]="filter.dealersExclusiveGroups && filter.dealersExclusiveGroups.indexOf(group.id) >= 0"
      (change)="updateExclusiveGroup(group.id, $event)"
    >
      {{ group.name }}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <label class="title-text cursor-pointer">Opcionais</label>
      <span class="title-text-clear curso" (click)="clearSelectedEquipment()">limpar</span>
    </div>
    <mat-checkbox
      class="d-block"
      *ngFor="let equipment of this.allEquipments?.slice(0, displayedEquipmentCount)"
      [(ngModel)]="equipment.selected"
      (change)="updateEquipmentOption(equipment, $event)"
    >
      {{ equipment.name }}
    </mat-checkbox>
    <span class="load-more" (click)="loadMoreEquipment()" *ngIf="allEquipments ? displayedEquipmentCount < allEquipments?.length : false">Mostrar mais</span>
    <span class="load-more" (click)="loadLessEquipment()" *ngIf="allEquipments ? displayedEquipmentCount >= allEquipments?.length : false">Mostrar menos</span>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="page === 'CAST_OFF' || page === 'ALL'">
    <div class="row">
      <div class="col-12">
        <label class="title-text mb-0">Publicado há</label>
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <mat-select (selectionChange)="handleFirstPublication($event)" [ngModel]="getFirstPublication()">
            <mat-option [value]="1">1 dia</mat-option>
            <mat-option [value]="2">2 dias</mat-option>
            <mat-option [value]="3">3 dias</mat-option>
            <mat-option [value]="4">4 dias</mat-option>
            <mat-option [value]="5">5 dias</mat-option>
            <mat-option [value]="6">6 dias</mat-option>
            <mat-option [value]="7">7 dias</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div class="row container-filter buttons-sticky">
  <div class="mat-divide"></div>
  <div class="col-lg-12 content-buttons">
    <div *ngIf="!isMyVehicles && canCreateFilter()" class="add-button-container d-md-inline-flex">
      <button (click)="emitterEventSaveFilter()" routerLinkActive="router-link-active" style="width: 90%" class="btn btn-rounded text-white">
        Salvar busca
      </button>
    </div>
    <div class="add-button-filter d-md-inline-flex" [class.w-100]="isMyVehicles">
      <button (click)="handleSubmitFilter()" routerLinkActive="router-link-active" class="btn btn-primary btn-rounded text-white" style="width: 100%">
        FILTRAR
      </button>
    </div>
  </div>
  <div class="col-lg-12 content-button-clear">
    <div class="add-button-clear d-md-inline-flex">
      <a routerLinkActive="router-link-active" (click)="routeToStart(); toggleSidebar()" class="btn button-clear"> Limpar filtros </a>
    </div>
  </div>
</div>
